import React from "react";
import "./AboutAppNeedSection.css";
import Icons from "../../../../config/images";

const AboutAppNeedSection = () => {
  return (
    <section className="about-app-need-section">
      <div className="about-app-need-container">
        {/* Left Content */}

        <div className="about-app-need-image">
          <img
            src={Icons.mobile_tab_image_2} // ✅ single combined image
            alt="Jewellery App Preview"
          />
        </div>
        {/* Right Image */}
        <div className="about-app-need-content">
          <h2>
            Why Your Jewellery Business
            <span> Needs a Digital Platform</span>
          </h2>

          <p>
            The jewellery industry is evolving rapidly. Customers expect
            convenience, transparency and seamless digital experiences. Relying
            only on physical stores or third-party marketplaces limits your
            growth and margins.
          </p>

          <p>
            A custom website or mobile app gives you complete control over your
            brand, data and customers.
          </p>
          <h3>Key Benefits</h3>
          <ul>
            <li>Reduce dependency on marketplaces & commissions</li>
            <li>Showcase your entire collection digitally</li>
            <li>Reach customers beyond geographical limits</li>
            <li>Enable faster order processing & inventory control</li>
            <li>Strengthen brand trust and visibility</li>
          </ul>

          <p>
            A dedicated digital platform is not an expense — it's a long-term
            investment in your brand's growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutAppNeedSection;
